export enum ExecutionEnvironment {
  production = 'prod',
  homologation = 'hom',
  development = 'dev',
  localhost = '127.0.0.1',
}
